import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url, Base_url_bbbs } from "../config";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import leave from '../component/leave.json'

let MonthlyReport = () => {
  let [data, setData] = useState();

  let navigate = useNavigate();
  let [sel, setSel] = useState("All");
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  let [startdate, setStartdate] = useState();
  let [enddate, setEnddate] = useState();

  let [load, setLoad] = useState(false);

  let [rent, setRent] = useState(0)

  // Function to open the popup
  const openPopup = () => {
    setIsPopupOpen(true);
  };

  // Function to close the popup
  const closePopup = () => {
    setIsPopupOpen(false);
  };

  useEffect(() => {
    Start();
    User()
    // Payment();
    // nerPayment();
  }, []);

  let Start = async () => {
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
    }
  };


  function validateDates(startDate, endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);

    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
      throw new Error("Invalid date format");
    }

    const isSameDay =
      start.getFullYear() === end.getFullYear() &&
      start.getMonth() === end.getMonth() &&
      start.getDate() === end.getDate();

    return isSameDay || start < end;
  }

  let User = async () => {

    setLoad(true); 

    try {
      const response = await axios.post(
        Base_url + "/admin/monthlyreport", 
      );

      let parsedata = AesDecrypt(response.data);
      let Jsson = JSON.parse(parsedata);
      console.log(Jsson, "ghbiufibi bvuid");
      if (Jsson.status === true) {
        setData(Jsson)  
      } else {
        alert("Error");
      }

    } catch (error) {
      console.error("Error", error);
    }
    setLoad(false);
  };


  function addWorkingDay(count, leave) {
    // Parse the input date string
    const date = new Date();

    // Initialize the count of days to add
    let addedDays = 0;

    // Helper to format date for comparison
    const formatDate = (d) =>
      d.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });

    // Loop until we've added the required number of working days
    while (addedDays < count) {
      date.setDate(date.getDate() + 1); // Add 1 day

      // Check if the day is not Sunday and not in the leave array
      if (date.getDay() !== 0 && !leave.includes(formatDate(date))) {
        addedDays++;
      }
    }

    const targetDate = new Date(date);

    return targetDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  }


 function newaddWorkingDayt3(count, twoo , hhh) {
        let currentDate = new Date(hhh); // Start with today's date
        let daysAdded = 0; // Keep track of how many valid days we've added
    
        // Helper function to check if the current date is in the 'twoo' array
        function isInTwoo(date) {
            let dateStr = date.toLocaleDateString("en-GB"); // Format date as 'DD/MM/YYYY'
            return twoo.includes(dateStr);
        }
    
        while (daysAdded < count) {
            currentDate.setDate(currentDate.getDate() + 1); // Move to the next day
            let dayOfWeek = currentDate.getDay(); // 0 is Sunday, 6 is Saturday
    
            // Skip Sundays
            if (dayOfWeek === 0) {
                continue;
            }
    
            // Skip all Saturdays
            if (dayOfWeek === 6) {
                continue;
            }
    
            // Skip dates in the 'twoo' array
            if (isInTwoo(currentDate)) {
                continue;
            }
    
            daysAdded++; // Only increment if it's a valid day (not skipped)
        }
    
        return currentDate.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit", 
            year: "numeric",
        });
      }

  let Redirect = async() => {
    
  }

  let ner = async() => {
    console.log(data?.edu.length)
  }


  let countreport =   ( ggggg ,valuee) =>{

    let sacont = 0
      ggggg?.map((dt, index) => {



        let jsonvalueee = JSON.parse(dt.charge)  

        if (jsonvalueee?.title === valuee  ) {
          sacont = sacont + 1 
        } 

      })

      return sacont

  }


  
  let countreportcard =   ( ggggg ,valuee) =>{

    let sacont = 0
      ggggg?.map((dt, index) => {



        let jsonvalueee = JSON.parse(dt.charge)  

        if (jsonvalueee?.title === valuee  ) {
          sacont = sacont + 1 
        } 

      })

      return sacont

  }


   let totalamountreportcard =   ( ggggg ,valuee) =>{

    let sacont = 0
      ggggg?.map((dt, index) => {
 


        let jsonvalueee = JSON.parse(dt.charge)  

        if (jsonvalueee?.title === valuee  ) {
          sacont =  sacont + Number( dt?.totalamount ) 
        } 

      })

      return sacont.toFixed(2);

  }

  let totalamountreportcardss =   ( ggggg ) =>{

    let sacont = 0
      ggggg?.map((dt, index) => {
 


        let jsonvalueee = JSON.parse(dt.charge)  
 
          sacont =  sacont + Number( dt?.totalamount ) 
        

      })

      return sacont.toFixed(2);

  }

  let totalamountreportvisa =   ( ggggg , typee ) =>{

    let sacont = 0
      ggggg?.map((dt, index) => {
 


      let jsonvalueee = JSON.parse(dt.typevalue)  

        if(jsonvalueee?.item?.name === typee  ) {

          sacont =  sacont + Number( dt?.totalamount ) 

        }
 
          
        

      })

      return sacont.toFixed(2);

  }



  return (
    <div>
      <div className="row">
        <Header />
         <div className="col-10">
          <div className="d-flex justify-content-between">
            <h4 style={{ textAlign: "center" }}>Monthly Report</h4>
          </div>  

          <h3 className="mt-4" style={{ fontWeight : "600" }} >This Month</h3>

          <div className="row" >

          
            <div className="col-3"   >

            </div>
            <div className="col-3"   >
            </div>
            <div className="col-3"   >
            </div>
            <div className="col-3"   >
            </div>
            <div className="col-3"   >
            </div>

          </div>

          <div className="row" >
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }} >
              
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }} >
              <p>Sameday</p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }} >
              <p>T1</p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
              <p>T2</p>
            </div> 
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
              <p>T3</p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
              <p>LOW / T4</p>
            </div>


            <div onClick={ner} className="col-2  " style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
              <p>Education  {"("} {data?.edu.length} {")"}</p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              { countreport(data?.edu , "Sameday") }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              { countreport(data?.edu , "T1") }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }} >
              { countreport(data?.edu , "T2") }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              { countreport(data?.edu , "T3") }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
               { countreport( data?.edu ,"Low") }
            </div>

            <div className="col-2  " style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
              <p>Utility  {"("} {data?.uti.length} {")"}</p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              { countreport(data?.uti ,"Sameday") }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              { countreport(data?.uti ,"T1") }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }} >
              { countreport(data?.uti ,"T2") }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              { countreport(data?.uti ,"T3") }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              { countreport(data?.uti ,"T4") }
            </div>



            <div className="col-2  " style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
             
              <p style={{color : 'green'}}>Total  {"("} {data?.uti.length+data?.edu.length} {")"}{" "} 
                 { (Number(totalamountreportcardss(data?.uti  )) + Number(totalamountreportcardss(data?.edu ))).toFixed(2) }
              </p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              { (Number(totalamountreportcard(data?.uti ,"Sameday")) + Number(totalamountreportcard(data?.edu , "Sameday"))).toFixed(2) }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              { (Number(totalamountreportcard(data?.uti ,"T1")) + Number(totalamountreportcard(data?.edu , "T1"))).toFixed(2) }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }} >
              { (Number(totalamountreportcard(data?.uti ,"T2")) + Number(totalamountreportcard(data?.edu , "T2"))).toFixed(2) }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              { (Number(totalamountreportcard(data?.uti ,"T3")) + Number(totalamountreportcard(data?.edu , "T3"))).toFixed(2) }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              { (Number(totalamountreportcard(data?.uti ,"T4")) + Number(totalamountreportcard(data?.edu , "T4"))).toFixed(2) }
            </div>


            <div className="col-2  " style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
             
              <p style={{color : 'red'}}>Visa :  
                 { (Number(totalamountreportvisa(data?.uti , 'visa'  )) + Number(totalamountreportvisa(data?.edu , 'visa' ))).toFixed(2) }
              </p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px",   fontWeight: "700" }}>
              <p style={{color : 'red'}}>Master :  
                 { (Number(totalamountreportvisa(data?.uti , 'master'  )) + Number(totalamountreportvisa(data?.edu , 'master' ))).toFixed(2) }
              </p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px",   fontWeight: "700" }}>
              <p style={{color : 'red'}}>RuPay :  
                 { (Number(totalamountreportvisa(data?.uti , 'RuPay'  )) + Number(totalamountreportvisa(data?.edu , 'RuPay' ))).toFixed(2) }
              </p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }} >
              <p style={{color : 'red'}}>AMEX :  
                 { (Number(totalamountreportvisa(data?.uti , 'AMEX'  )) + Number(totalamountreportvisa(data?.edu , 'AMEX' ))).toFixed(2) }
              </p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px",  fontWeight: "700" }}>
              <p style={{color : 'red'}}>Dynex :  
                 { (Number(totalamountreportvisa(data?.uti , 'Dynex'  )) + Number(totalamountreportvisa(data?.edu , 'Dynex' ))).toFixed(2) }
              </p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
              <p style={{color : 'red'}}>Prepaid :  
                 { (Number(totalamountreportvisa(data?.uti , 'Prepaid'  )) + Number(totalamountreportvisa(data?.edu , 'Prepaid' ))).toFixed(2) }
              </p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
              <p style={{color : 'red'}}>Wallet :  
                 { (Number(totalamountreportvisa(data?.uti , 'Wallet'  )) + Number(totalamountreportvisa(data?.edu , 'Wallet' ))).toFixed(2) }
              </p>
            </div>




          </div>


          <h3 className="mt-5" style={{ fontWeight : "600" }} >Previous Month</h3>
          <div className="row" >
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }} >
              
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }} >
              <p>Sameday</p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }} >
              <p>T1</p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
              <p>T2</p>
            </div> 
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
              <p>T3</p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
              <p>LOW / T4</p>
            </div>


            <div onClick={ner} className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
              <p>Education  {"("} {data?.eduprevious.length} {")"}</p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              { countreport(data?.eduprevious ,"Sameday") }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              { countreport(data?.eduprevious ,"T1") }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }} >
              { countreport(data?.eduprevious ,"T2") }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              { countreport(data?.eduprevious ,"T3") }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              { countreport(data?.eduprevious ,"Low") }
            </div>

            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
              <p>Utility  {"("} {data?.utiprevious.length} {")"}</p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              { countreport(data?.utiprevious ,"Sameday") }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              { countreport(data?.utiprevious ,"T1") }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }} >
              { countreport(data?.utiprevious ,"T2") }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              { countreport(data?.utiprevious ,"T3") }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              { countreport(data?.utiprevious ,"T4") }
            </div>



            <div className="col-2  " style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
              <p style={{color : 'green'}}>Total  {"("} {data?.eduprevious.length+data?.utiprevious.length} {")"}{" "} 
                 { (Number(totalamountreportcardss(data?.eduprevious  )) + Number(totalamountreportcardss(data?.utiprevious ))).toFixed(2) }</p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              { (Number(totalamountreportcard(data?.utiprevious ,"Sameday")) + Number(totalamountreportcard(data?.eduprevious , "Sameday"))).toFixed(2) }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              { (Number(totalamountreportcard(data?.utiprevious ,"T1")) + Number(totalamountreportcard(data?.eduprevious , "T1"))).toFixed(2) }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }} >
              { (Number(totalamountreportcard(data?.utiprevious ,"T2")) + Number(totalamountreportcard(data?.eduprevious , "T2"))).toFixed(2) }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              { (Number(totalamountreportcard(data?.utiprevious ,"T3")) + Number(totalamountreportcard(data?.eduprevious , "T3"))).toFixed(2) }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              { (Number(totalamountreportcard(data?.utiprevious ,"T4")) + Number(totalamountreportcard(data?.eduprevious , "Low"))).toFixed(2) }
            </div>



            <div className="col-2  " style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
             
              <p style={{color : 'red'}}>Visa :  
                 { (Number(totalamountreportvisa(data?.utiprevious , 'visa'  )) + Number(totalamountreportvisa(data?.eduprevious , 'visa' ))).toFixed(2) }
              </p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px",   fontWeight: "700" }}>
              <p style={{color : 'red'}}>Master :  
                 { (Number(totalamountreportvisa(data?.utiprevious , 'master'  )) + Number(totalamountreportvisa(data?.eduprevious , 'master' ))).toFixed(2) }
              </p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px",   fontWeight: "700" }}>
              <p style={{color : 'red'}}>RuPay :  
                 { (Number(totalamountreportvisa(data?.utiprevious , 'RuPay'  )) + Number(totalamountreportvisa(data?.eduprevious , 'RuPay' ))).toFixed(2) }
              </p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }} >
              <p style={{color : 'red'}}>AMEX :  
                 { (Number(totalamountreportvisa(data?.utiprevious , 'AMEX'  )) + Number(totalamountreportvisa(data?.eduprevious , 'AMEX' ))).toFixed(2) }
              </p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px",  fontWeight: "700" }}>
              <p style={{color : 'red'}}>Dynex :  
                 { (Number(totalamountreportvisa(data?.utiprevious , 'Dynex'  )) + Number(totalamountreportvisa(data?.eduprevious , 'Dynex' ))).toFixed(2) }
              </p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
              <p style={{color : 'red'}}>Prepaid :  
                 { (Number(totalamountreportvisa(data?.utiprevious , 'Prepaid'  )) + Number(totalamountreportvisa(data?.eduprevious , 'Prepaid' ))).toFixed(2) }
              </p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
              <p style={{color : 'red'}}>Wallet :  
                 { (Number(totalamountreportvisa(data?.utiprevious , 'Wallet'  )) + Number(totalamountreportvisa(data?.eduprevious , 'Wallet' ))).toFixed(2) }
              </p>
            </div>




          </div>
  
        </div>
      </div>
    </div>
  );
};

export default MonthlyReport;
